export default {
  '***': {
    '***': {
      displayFilters: null,
      staticFilters: [
        {
          label: 'Age',
          code: 'age',
          multi: true,
          options: [  
            {
              label: '18-24',
              value: 1,
              selected: false
            },
            {
              label: '25-34',
              value: 2,
              selected: false
            },
            {
              label: '35-54',
              value: 3,
              selected: false
            },
            {
              label: '55-64',
              value: 4,
              selected: false
            },
            {
              label: '65+',
              value: 5,
              selected: false
            }
          ]
        },
        {
          label: 'Gender',
          code: 'gender',
          multi: true,
          options: [
            {
              label: 'Male',
              value: 1,
              selected: false
            },
            {
              label: 'Female',
              value: 2,
              selected: false
            },
            {
              label: 'Other',
              value: 3,
              selected: false
            }
          ]
        },
        {
          label: 'Income',
          code: 'income',
          multi: true,
          options: [    
            {
              label: 'Value',
              value: 1,
              selected: false
            },
            {
              label: 'Core',
              value: 2,
              selected: false
            },
            {
              label: 'Up',
              value: 3,
              selected: false
            }
          ]
        },
        {
          label: 'Ethnicity',
          code: 'ethnicity',
          multi: true,
          options: [
            {
              label: 'White',
              value: 1,
              selected: false
            },
            {
              label: 'Black/African American',
              value: 2,
              selected: false
            },
            {
              label: 'Hispanic/Latino',
              value: 3,
              selected: false
            },
            {
              label: 'Asian',
              value: 4,
              selected: false
            },
            {
              label: 'American Indian/Alaskan Native',
              value: 5,
              selected: false
            },
            {
              label: 'Middle Eastern/North African',
              value: 6,
              selected: false
            },
            {
              label: 'Hawaiian/Pacific Islander',
              value: 7,
              selected: false
            },
            {
              label: 'Other/Multi',
              value: 8,
              selected: false
            }
          ]
        },
        {
          label: 'Market',
          code: 'market',
          multi: true,
          options: [
            {
              label: 'Austin / Central',
              value: 1,
              selected: false
            },
            {
              label: 'San Antonio',
              value: 2,
              selected: false
            },
            {
              label: 'Houston',
              value: 3,
              selected: false
            },
            {
              label: 'North Texas / DFW',
              value: 4,
              selected: false
            },
            {
              label: 'Border Region',
              value: 5,
              selected: false
            }
          ]
        },
        {
          label: 'Shopper',
          // excludeFromVerbatims: true,
          code: 'shopper',
          multi: true,
          options: [
            {
              label: 'Loyals',
              value: 1,
              selected: false
            },
            {
              label: 'Splitters',
              value: 2,
              selected: false
            },
            {
              label: 'Occasionals',
              value: 3,
              selected: false
            },
            {
              label: 'Non-Shopper',
              value: 4,
              selected: false
            }
          ]
        },
        {
          label: 'GM Media Target',
          code: 'gm',
          multi: true,
          options: [
            {
              label: 'GM Media Target (25-54)',
              value: 1,
              selected: false
            },
            {
              label: 'GM Media Non-Target',
              value: 2,
              selected: false
            }
          ]
        },
        {
          label: 'HM Media Target',
          code: 'hm',
          multi: true,
          options: [
            {
              label: 'HM Media Target (18-49)',
              value: 1,
              selected: false
            },
            {
              label: 'HM Media Non-Target',
              value: 2,
              selected: false
            }
          ]
        }
      ]
    }
  }
};


// WEBPACK FOOTER //
// ./src/app/configuration/HEB/config/components/scorecard/ScorecardView/ScorecardFilter/index.js